import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "../../../api/client";

/**
 * Links an alta-rápida provisional profile to a formal student, migrating its
 * history and deducting the migrated hours from the real student.
 * mutate({ provisionalId, targetStudentId }).
 */
function useLinkProvisional(planningId) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ provisionalId, targetStudentId }) => {
      const res = await apiClient.post("/api/v1/students/link-provisional/", {
        provisional_id: provisionalId,
        target_student_id: targetStudentId,
      });
      return res.data;
    },
    onSuccess: () => {
      if (planningId) {
        queryClient.invalidateQueries({
          queryKey: ["plannings", planningId, "roster"],
        });
      }
      queryClient.invalidateQueries({ queryKey: ["teacher", "student-search"] });
    },
  });
}

export { useLinkProvisional };
